// Home-page sections: all products of a section are rendered server-side;
// show them one page at a time with a client-side pager.
const pageSize = 9;

document.querySelectorAll('.home-section').forEach(function(section) {
	const items = Array.from(section.querySelectorAll('.item'));
	const pageCount = Math.ceil(items.length / pageSize);
	section.classList.add('home-section--paged');

	if (pageCount < 2) {
		return;
	}

	const pager = document.createElement('div');
	pager.className = 'home-section__pager';

	const buttons = [];
	for (let page = 0; page < pageCount; page++) {
		const button = document.createElement('button');
		button.type = 'button';
		button.textContent = page + 1;
		button.addEventListener('click', function() {
			showPage(page);
		});
		pager.appendChild(button);
		buttons.push(button);
	}

	function showPage(page) {
		items.forEach(function(item, i) {
			item.classList.toggle('item--page-hidden', Math.floor(i / pageSize) !== page);
		});
		buttons.forEach(function(button, i) {
			button.classList.toggle('active', i === page);
		});
	}

	showPage(0);
	section.appendChild(pager);
});
